import type { CombinedError } from "urql"
import { useQuery } from "urql"

import "../graphql/queries"
import {
  GetProductInventoryDetailDocument,
  type GetProductInventoryDetailQuery,
  type InventoryByProductItem,
} from "@/graphql/codegen/graphql"

interface UseGetProductInventoryReturn {
  inventory: InventoryByProductItem | null
  isFetching: boolean
  error: CombinedError | undefined
}

export const useGetProductInventory = (productId: number): UseGetProductInventoryReturn => {
  const [{ data, fetching, error }] = useQuery<GetProductInventoryDetailQuery>({
    query: GetProductInventoryDetailDocument,
    variables: { productId },
    pause: !productId,
  })

  const items =
    data?.inventory.listByProduct.__typename === "InventoryByProductListSuccess"
      ? (data.inventory.listByProduct.items as InventoryByProductItem[])
      : []

  return {
    inventory: items[0] ?? null,
    isFetching: fetching,
    error,
  }
}
